import React from "react";
import Selector from "@ui/Selector";
import { orderingOptions, useOrdering } from "./useOrdering";
import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";

function OrderingSelector() {
  const [selectedOrdering, setSelectedOrdering] = useOrdering({});

  return (
    <Selector
      options={orderingOptions}
      value={selectedOrdering}
      onChange={setSelectedOrdering}
      className={HIDE_ON_WIDGET_EXPORT}
    />
  );
}

export default React.memo(OrderingSelector);
